import { useMemo } from 'react';
import { filterPreviousSelectedLanguages } from '../helpers';
import { languagePreviouslySelectedLocalStorageKey } from '../types';

export const useFilterPreviousSelectedLanguages = (): string[] => {
  return useMemo(() => {
    return filterPreviousSelectedLanguages(
      languagePreviouslySelectedLocalStorageKey,
    );
  }, []);
};
